import { baseRoutes, pathHelpers } from '@routes/helpers/baseRoutes';
import { interpolatePath, sub } from '@routes/helpers/pathHelpers';

export const routesPaths = {
  invitations: {
    root: pathHelpers.invitations(''),
    responseDetails: (id: string, responseId: string) =>
      pathHelpers.invitations(
        interpolatePath(baseRoutes.invitations.responseDetails, { id, responseId })
      ),
    details: (id: string) =>
      pathHelpers.invitations(interpolatePath(baseRoutes.invitations.details, { id }))
  },
  responses: {
    root: pathHelpers.responses(''),
    details: (id: string) =>
      pathHelpers.responses(interpolatePath(baseRoutes.responses.details, { id }))
  },
  approvals: {
    root: pathHelpers.approvals(''),
    details: (id: string) =>
      pathHelpers.approvals(interpolatePath(baseRoutes.approvals.details, { id }))
  },
  studio: {
    root: pathHelpers.studio(''),
    forms: {
      root: pathHelpers.studio(baseRoutes.studio.forms.root),
      details: (id: string) =>
        pathHelpers.studio(interpolatePath(baseRoutes.studio.forms.details, { id })),
      creator: (id: string) =>
        pathHelpers.studio(interpolatePath(baseRoutes.studio.forms.creator, { id }))
    },
    formGroups: {
      root: pathHelpers.studio(baseRoutes.studio.formGroups.root),
      details: (id: string) =>
        pathHelpers.studio(interpolatePath(baseRoutes.studio.formGroups.details, { id }))
    },
    reporting: {
      root: pathHelpers.studio(baseRoutes.studio.reporting.root),
      reports: pathHelpers.studio(baseRoutes.studio.reporting.reports),
      reportDetails: (id: string) =>
        pathHelpers.studio(interpolatePath(baseRoutes.studio.reporting.reportDetails, { id })),
      reportDesigner: (id: string) =>
        pathHelpers.studio(interpolatePath(baseRoutes.studio.reporting.reportDesigner, { id })),
      textwidgets: pathHelpers.studio(baseRoutes.studio.reporting.textwidgets),
      newTextWidget: pathHelpers.studio(baseRoutes.studio.reporting.newTextWidget),
      textwidgetDetails: (id: string) =>
        pathHelpers.studio(interpolatePath(baseRoutes.studio.reporting.textwidgetDetails, { id }))
    },
    expressions: {
      root: pathHelpers.studio(baseRoutes.studio.expressions.root),
      details: (id: string) =>
        pathHelpers.studio(interpolatePath(baseRoutes.studio.expressions.details, { id })),
      new: pathHelpers.studio(baseRoutes.studio.expressions.new)
    },
    automations: {
      root: pathHelpers.studio(baseRoutes.studio.automations.root),
      workflows: pathHelpers.studio(baseRoutes.studio.automations.workflows),
      workflowDetails: (id: string) =>
        pathHelpers.studio(interpolatePath(baseRoutes.studio.automations.workflowDetails, { id })),
      newWorkflow: pathHelpers.studio(baseRoutes.studio.automations.newWorkflow),
      logs: pathHelpers.studio(baseRoutes.studio.automations.logs),
      logDetails: (id: string) =>
        pathHelpers.studio(interpolatePath(baseRoutes.studio.automations.logDetails, { id }))
    },
    taxonomies: {
      root: pathHelpers.studio(baseRoutes.studio.taxonomies.root),
      categories: pathHelpers.studio(baseRoutes.studio.taxonomies.categories),
      tags: pathHelpers.studio(baseRoutes.studio.taxonomies.tags)
    }
  },
  iam: {
    root: pathHelpers.iam(''),
    users: {
      root: pathHelpers.iam(baseRoutes.iam.users.root),
      details: (id: string) =>
        pathHelpers.iam(interpolatePath(baseRoutes.iam.users.details, { id })),
      new: pathHelpers.iam(baseRoutes.iam.users.new)
    },
    lists: {
      root: pathHelpers.iam(baseRoutes.iam.lists.root),
      details: (id: string) =>
        pathHelpers.iam(interpolatePath(baseRoutes.iam.lists.details, { id })),
      new: pathHelpers.iam(baseRoutes.iam.lists.new)
    },
    roles: {
      root: pathHelpers.iam(baseRoutes.iam.roles.root),
      details: (id: string) =>
        pathHelpers.iam(interpolatePath(baseRoutes.iam.roles.details, { id })),
      new: pathHelpers.iam(baseRoutes.iam.roles.new)
    },
    userGroups: {
      root: pathHelpers.iam(baseRoutes.iam.userGroups.root),
      details: (id: string) =>
        pathHelpers.iam(interpolatePath(baseRoutes.iam.userGroups.details, { id })),
      new: pathHelpers.iam(baseRoutes.iam.userGroups.new)
    }, //done
    nodes: {
      root: pathHelpers.iam(baseRoutes.iam.nodes.root),
      details: (id: string) =>
        pathHelpers.iam(interpolatePath(baseRoutes.iam.nodes.details, { id })),
      new: pathHelpers.iam(baseRoutes.iam.nodes.new)
    }
  },
  campaigns: {
    root: pathHelpers.campaigns(''),
    list: {
      root: pathHelpers.campaigns(baseRoutes.campaigns.list.root),
      details: (id: string) =>
        pathHelpers.campaigns(interpolatePath(baseRoutes.campaigns.list.details, { id })),
      new: pathHelpers.campaigns(baseRoutes.campaigns.list.new)
    },
    tags: pathHelpers.campaigns(baseRoutes.campaigns.tags)
  },
  accounts: {
    root: pathHelpers.accounts(''),
    entities: {
      root: pathHelpers.accounts(baseRoutes.accounts.entities.root),
      details: (id: string) => pathHelpers.accounts(`${baseRoutes.accounts.entities.root}/${id}`),
      new: pathHelpers.accounts(`${baseRoutes.accounts.entities.root}/new`)
    },
    groupEntities: {
      root: pathHelpers.accounts(baseRoutes.accounts.groupEntities.root),
      details: (id: string) =>
        pathHelpers.accounts(`${baseRoutes.accounts.groupEntities.root}/${id}`),
      new: pathHelpers.accounts(`${baseRoutes.accounts.groupEntities.root}/new`)
    },
    dataPools: {
      root: pathHelpers.accounts(baseRoutes.accounts.dataPools.root),
      details: (id: string) => pathHelpers.accounts(`${baseRoutes.accounts.dataPools.root}/${id}`),
      new: pathHelpers.accounts(`${baseRoutes.accounts.dataPools.root}/new`)
    },
    tags: pathHelpers.accounts(baseRoutes.accounts.tags)
  },
  api: {
    root: pathHelpers.api('')
  },
  solvers: {
    root: pathHelpers.solvers(''),
    details: (id: string) =>
      pathHelpers.solvers(interpolatePath(baseRoutes.solvers.details, { id })),
    historyDetails: (id: string, itemId: string) =>
      pathHelpers.solvers(interpolatePath(baseRoutes.solvers.historyDetails, { id, itemId })),
    new: pathHelpers.solvers(baseRoutes.solvers.new)
  },
  files: {
    root: pathHelpers.files(''),
    details: (id: string) => pathHelpers.files(interpolatePath(baseRoutes.files.details, { id }))
  },
  tables: {
    root: pathHelpers.tables(''),
    details: (id: string) => pathHelpers.tables(interpolatePath(baseRoutes.tables.details, { id })),
    itemDetails: (id: string, itemId: string) =>
      pathHelpers.tables(interpolatePath(baseRoutes.tables.itemDetails, { id, itemId })),
    newItem: (id: string) => pathHelpers.tables(interpolatePath(baseRoutes.tables.newItem, { id }))
  },
  accountSettings: {
    root: pathHelpers.accountSettings(''),
    settings: pathHelpers.accountSettings(baseRoutes.accountSettings.settings),
    emails: pathHelpers.accountSettings(baseRoutes.accountSettings.emails),
    branding: pathHelpers.accountSettings(baseRoutes.accountSettings.branding),
    profile: pathHelpers.accountSettings(baseRoutes.accountSettings.profile),
    logs: pathHelpers.accountSettings(baseRoutes.accountSettings.logs),
    logDetails: (id: string) =>
      pathHelpers.accountSettings(interpolatePath(baseRoutes.accountSettings.logDetails, { id }))
  },
  datapools: {
    root: pathHelpers.datapools(''),
    details: (id: string) =>
      pathHelpers.datapools(interpolatePath(baseRoutes.datapools.details, { id }))
  },
  insights: {
    root: pathHelpers.insights(''),
    details: (id: string) =>
      pathHelpers.insights(interpolatePath(baseRoutes.insights.details, { id }))
  },
  learningCenter: {
    root: pathHelpers.learningCenter(''),
    details: (id: string) =>
      pathHelpers.learningCenter(interpolatePath(baseRoutes.learningCenter.details, { id })),
    history: pathHelpers.learningCenter(baseRoutes.learningCenter.history),
    historyDetails: (id: string, historyId: string) =>
      pathHelpers.learningCenter(
        interpolatePath(baseRoutes.learningCenter.historyDetails, { id, historyId })
      ),
    newResponse: (id: string) =>
      pathHelpers.learningCenter(interpolatePath(baseRoutes.learningCenter.newResponse, { id })),
    responseDetails: (id: string, responseId: string) =>
      pathHelpers.learningCenter(
        interpolatePath(baseRoutes.learningCenter.responseDetails, { id, responseId })
      )
  },
  userProfile: {
    root: pathHelpers.userProfile('')
  },
  workspace: {
    root: pathHelpers.workspace(''),
    details: (id: string) =>
      pathHelpers.workspace(interpolatePath(baseRoutes.workspace.details, { id })),
    newResponse: (id: string) =>
      pathHelpers.workspace(interpolatePath(baseRoutes.workspace.newResponse, { id })),
    responseDetails: (id: string, responseId: string) =>
      pathHelpers.workspace(
        interpolatePath(baseRoutes.workspace.responseDetails, { id, responseId })
      ),
    history: pathHelpers.workspace(baseRoutes.workspace.history),
    historyDetails: (id: string) =>
      pathHelpers.workspace(interpolatePath(baseRoutes.workspace.historyDetails, { id }))
  }
} as const;

// learning center routes
const LEARNING_CENTER_ROOT = 'learning-center';

export const LEARNING_CENTER_ROUTES = {
  root: LEARNING_CENTER_ROOT,
  learningCenter: sub('learning-center', {
    details: ':id'
  })
} as const;
export type LearningCenterSection = keyof Omit<typeof LEARNING_CENTER_ROUTES, 'root'>;
export function learningCenterPath<T extends string>(
  segment: T
): `/${typeof LEARNING_CENTER_ROUTES.root}/${T}` {
  return `/${LEARNING_CENTER_ROUTES.root}/${segment}`;
}

export type EntitiesSection = 'entities' | 'group-entities' | 'data-pools' | 'tags';
